import { useEffect } from 'react';

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);  // 将页面滚动到顶部
  }, []);  // 空数组表示只会在组件挂载时执行一次

  return null; // 这个组件不渲染任何内容
};

export default ScrollToTop;